'use client'

import { Button } from '@repo/design-system-cf/components/button'
import { StartFreeTrialButton } from 'payments/start-free-trial-button'
import { PAYMENT_ENTRY_POINTS } from 'payments/payments-dialog/analytics'

export function CtaButton({ label }: { label: string }) {
  return (
    <Button
      variant="primary-green-bright"
      size="large"
      className="w-full whitespace-normal py-2.5 text-center leading-tight hover:text-cf-white"
      asChild
    >
      <StartFreeTrialButton entryPoint={PAYMENT_ENTRY_POINTS.CATEGORY_PAGE_IMAGE} label={label} />
    </Button>
  )
}
